<template>
	<div class="top-hero">
		<div class="container">
			<div class="top-content" :class="$i18n.locale">
				<div class="left-content">
					<h3>
						<span v-html="$t('TopHero.title')" class="title"></span>
						<span
							v-html="$t('TopHero.subtitle')"
							class="subtitle"
						></span>
					</h3>
				</div>
				<div v-if="$i18n.locale == 'en'" class="right-content">
					<img
						class="desktop"
						src="~@/assets/img/brought-to-you-desktop.png"
						alt="Manulife Logo"
					/>
					<img
						class="mobile"
						src="~@/assets/img/brought-to-you-mobile.png"
						alt="Manulife Logo"
					/>
				</div>
				<div v-else class="right-content">
					<img
						class="desktop"
						src="~@/assets/img/brought-to-you-desktop-fr.png"
						alt="Manulife Logo"
					/>
					<img
						class="mobile"
						src="~@/assets/img/brought-to-you-mobile-fr.png"
						alt="Manulife Logo"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TopHero',
}
</script>

<style scoped lang="scss">
.top-hero {
	background: linear-gradient(90deg, $blueTheme 68%, $white 32%);
}

.container {
	max-width: 1405px;
	padding: 0;
}

.top-content {
	@include flex-container(flex-end, flex-start, center);
	margin: 10px auto 0;
	z-index: 10;
	height: 80px;
	background-color: $blueTheme;
	width: 100%;
	color: $white;

	&.fr {
		h3 {
			font-size: 30px;
		}
	}
}

.left-content {
	@include flex-container(flex-start, flex-start, center);
	width: 65%;
	height: 80px;
	padding: 22px 0;
}

.right-content {
	@include flex-container(flex-start, flex-start, center);
	background-color: $white;
	height: 80px;
	padding: 20px 0;
	width: 35%;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		width: 28px;
		height: 28px;
		background-image: url($pathToAssets+'img/blue-diamond.png');
		left: -14px;
		top: 26px;
	}

	img {
		width: 370px;
		max-width: 80%;
		margin-left: 45px;
		align-self: center;

		&.mobile {
			display: none;
		}
	}
}

h3 {
	margin-left: 7%;
	align-self: center;
}

.title {
	span {
		color: red;
	}
}

.subtitle {
	@extend %gilroy;
}

@include littleDesktop {
	.top-content {
		h3 {
			margin-left: 60px;
		}

		&.fr {
			h3 {
				font-size: 2.1vw;
				z-index: 3;
			}
		}
	}
}

@include collapsed {
	h3 {
		font-size: 2.4vw;
	}

	.right-content {
		img {
			margin-left: 30px;
		}
	}
}

@include mobile {
	.top-content {
		display: block;
		height: auto;

		h3 {
			margin-left: 0;
		}

		&.fr {
			h3 {
				font-size: 24px;
			}
		}
	}

	.left-content,
	.right-content {
		width: 100%;
	}

	.left-content {
		height: 90px;
	}

	h3 {
		width: 100%;
		font-size: 24px;
		margin: 6px 0 2px;
		text-align: center;

		.subtitle {
			display: block;
		}
	}

	.right-content {
		align-items: center;
		justify-content: center;
		height: 90px;

		&::before {
			left: calc(50% - 14px);
			top: -15px;
		}

		img {
			max-height: 60px;
			width: auto;
			margin: 0 auto;

			&.desktop {
				display: none;
			}

			&.mobile {
				display: block;
			}
		}
	}
}
</style>
